import React from 'react';
import {Card, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  imgStyle:{
    //height:200,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class ExperienceSketchTracer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="SketchTracer, Sole Developer"
          subtitle="Mobile App: 2017-2019"
          avatar="images/sketchtracer.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >
          <div>
            <ul>
              <li>
                Design and development of a mobile application
              </li>
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  HTML/CSS/Javascript
                </Chip>
                <Chip style={styles.chip}>
                  React
                </Chip>
                <Chip style={styles.chip}>
                  Cordova
                </Chip>
                <Chip style={styles.chip}>
                  Bootstrap
                </Chip>
                <Chip style={styles.chip}>
                  AdMob
                </Chip>
              </div>
            </ul>
          </div>
        </CardText>
        <CardMedia
          expandable={true}
          overlay={<CardTitle title="SketchTracer" subtitle="" />}
        >
          <img
            src="images/sketchtracer_app.jpg" alt=""
            style={styles.imgStyle}
          />
        </CardMedia>
        <CardText expandable={true}>
          <ul>
            <li>SketchTracer is a drawing app that lets you sketch on top of any image or photo. Fade the background in and out to make hand-drawn sketches.</li>
            <li>Cross-platform programming (iOS and Android) using Cordova</li>
          </ul>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperienceSketchTracer.js